<div class="main-outer-div flex-grow-1 flex-shrink-1 pt-4">
  <div class="mb-4">
    <h1>{{ 'createProposal.title' | translate }}</h1>
    <span class="title-2">{{ 'createProposal.sub_title' | translate }}</span>
  </div>
  <div class="d-flex justify-content-between align-items-end form-title-section-buttons">
    <button class="menu-button" (click)="cancel()">{{'cancel'|translate}}</button>
    <button [disabled]="!((allFormsValid$|async) && allUploadsComplete$|async) || saveProposalButtonDisabled"
            (click)="navigateToPreview()"
            class="save-button menu-button show-preview-button">
      <span class="cursor-pointer">
        {{'showPreview' | translate}}
      </span>
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>

  <div #buttons class="left">
    <div class="white-box">

      <div class="form-steps-container-title">

        <div class="form-steps-title-section-row-1">
          <div class="form-steps-title-section-left">
            <div class="section-title" style="margin-right: 10px">
              {{'formStepsSection.title'|translate}}
            </div>
            <div *ngIf="(showMissingInformation$|async)" class="form-steps-title-section-error">
              <div class="form-steps-title-section-error-logo">
                <img alt="warning" src="assets/svg-icons/warning_amber.svg">
              </div>
              <div class="form-steps-title-section-error-text">
                {{'formStepsSection.error'|translate}}
              </div>
            </div>
          </div>
          <div>
            <div class="form-steps-title-section-arrow" (click)="expand()" *ngIf="expandMore">
              <mat-icon>expand_more</mat-icon>
            </div>
            <div class="form-steps-title-section-arrow" (click)="expand()" *ngIf="!expandMore">
              <mat-icon>expand_less</mat-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column " style="float: right; width: 100%">

        <ng-container *ngFor="let title of titles;let i = index">
          <ng-container>
            <div [ngClass]="{'not-show': !expandMore && !(i==scrolled)}">
              <div (click)="scroll(idNames[i])" [id]="idNames[i]+'button'"
                   [ngClass]="{'selectedSection': scrolled == i}"
                   class="form-steps-list-row">

                <div class="form-steps-list-row-error-non-visible"
                     [ngClass]="{'form-steps-list-row-error': !(validChildForm[i] | async)&& i < maxScrolled && scrolled!= i}">
                  <div class=" form-steps-list-items">
                    <ng-container>
                      <ng-container *ngIf="(validChildForm[i] | async) && maxScrolled > i">
                        <ng-container *ngTemplateOutlet="validCircle"></ng-container>
                      </ng-container>

                      <ng-container
                        *ngIf="!(validChildForm[i] | async) && i < maxScrolled">
                        <ng-container *ngTemplateOutlet="errorIcon"></ng-container>
                      </ng-container>

                      <ng-container
                        *ngIf="i >= maxScrolled && i !== scrolled && i !== 9">
                        <ng-container *ngTemplateOutlet="emptyCircle"></ng-container>
                      </ng-container>

                      <ng-container
                        *ngIf="(validChildForm[i] | async) && i === scrolled && i >= maxScrolled && i !== 9">
                        <ng-container *ngTemplateOutlet="selectedCircle"></ng-container>
                      </ng-container>


                      <ng-container
                        *ngIf="!(validChildForm[i] | async) && scrolled === i && maxScrolled === i && i !== 9">
                        <ng-container *ngTemplateOutlet="selectedCircle"></ng-container>
                      </ng-container>


                      <ng-container *ngIf="i === 9 && (allUploadsComplete$|async)">
                        <ng-container *ngTemplateOutlet="validCircle"></ng-container>
                      </ng-container>

                      <ng-container
                        *ngIf="i === 9 && !(allUploadsComplete$|async)">
                        <ng-container *ngTemplateOutlet="spinnerCircle"></ng-container>
                      </ng-container>

                    </ng-container>
                    <span class="progress-bar-text">

                        {{(i + 1) + '/10'}}
                      {{'createProposal.' + title|translate}}
                      <ng-container
                        *ngIf="i==3 && riskDataComponent?.formGroup?.value?.lineOfBusiness">- {{'lineOfBusiness.clauses.' + riskDataComponent.formGroup.value.lineOfBusiness + '.name' | translate}}</ng-container>
                  </span>
                  </div>
                </div>

              </div>
              <div *ngIf="titles[i+1] !== undefined && expandMore" class="vertical-line"></div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="bottom-padding"></div>
    </div>

    <div *ngIf="!expandMore" class="your-data">
      <app-your-data-create-proposal></app-your-data-create-proposal>
    </div>
  </div>
  <div #rightPart id="rightPart" class="right" (scroll)="onWindowScroll(rightPart)">


    <div class="section pt-4" [id]="idNames[0]">
      <app-partner-information-form
        [partner]="(proposalPreview|async)?.partner || proposal.partner"></app-partner-information-form>
      <hr>
    </div>

    <div class="section" [id]="idNames[1]">
      <app-risk-data-form [proposalPreview]="(proposalPreview|async)"></app-risk-data-form>
      <hr>
    </div>

    <div class="section" [id]="idNames[2]">
      <app-amount-insured-form
        [isEditRoute]="isEditRoute"
        [selectedLineOfBusinessNumber]="riskDataComponent?.formGroup?.getRawValue()?.lineOfBusiness"
        [proposalPreviewInformation]="(proposalPreview|async)?.proposalInformation"
        (scrollToSkendata)="scroll(idNames[4])"></app-amount-insured-form>
      <hr>
    </div>

    <div class="section" [id]="idNames[3]">
      <app-risk-description-form
        [proposalPreviewInformation]="(proposalPreview|async)?.proposalInformation"
        [selectedLineOfBusinessNumber]="riskDataComponent?.formGroup?.value?.lineOfBusiness"
        [hasRiskLocationInput]="hasRiskLocationInput">
      </app-risk-description-form>
      <hr>
    </div>

    <div class="section" [id]="idNames[4]">
      <app-risk-location-form [proposalPreview]="(proposalPreview|async)"
                              (riskLocationCompleted)="onRiskLocationCompleted($event)"></app-risk-location-form>
      <hr>
    </div>

    <div class="section" [id]="idNames[5]">
      <app-international-program [proposalPreviewCountriesWithLocalPolicies]="(proposalPreview|async)?.proposalInformation?.countriesWithLocalPolicies"></app-international-program>
      <hr>
    </div>

    <div class="section" [id]="idNames[6]">
      <app-previous-damage-form [proposalPreview]="(proposalPreview|async)"></app-previous-damage-form>
      <hr>
    </div>

    <div class="section" [id]="idNames[7]">
      <app-individual-clauses-conditions-form [proposalPreviewInformation]="(proposalPreview|async)?.proposalInformation"></app-individual-clauses-conditions-form>
      <hr>
    </div>

    <div class="section" [id]="idNames[8]">
      <app-ad-information-form
        [isEditRoute]="isEditRoute"
        [proposalPreviewInformation]="(proposalPreview|async)?.proposalInformation"
        [selectedLineOfBusinessNumber]="riskDataComponent?.formGroup?.getRawValue()?.lineOfBusiness"></app-ad-information-form>
      <hr>
    </div>

    <div class="section pb-3" [id]="idNames[9]">
      <app-proposal-upload-summary></app-proposal-upload-summary>
    </div>
    <div class="d-flex justify-content-around align-items-center mt-3">
      <div *ngIf="!(allFormsValid$|async)" class="form-steps-title-section-error">
        <div class="form-steps-title-section-error-logo">
          <img alt="warning" src="assets/svg-icons/warning_amber.svg">
        </div>
        <div class="form-steps-title-section-error-text">
          {{'formStepsSection.error'|translate}}
        </div>
      </div>
      <div *ngIf="!(allUploadsComplete$|async)" class="form-steps-title-section-error">
        <div class="form-steps-title-section-error-logo">
          <img alt="warning" src="assets/svg-icons/warning_amber.svg">
        </div>
        <div class="form-steps-title-section-error-text">
          {{'formStepsSection.uploadsIncomplete'|translate}}
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-around align-items-center mt-3">
      <button [disabled]="!((allFormsValid$|async) && allUploadsComplete$|async) || saveProposalButtonDisabled"
              (click)="navigateToPreview()"
              class="menu-button save-button mt-4 last-button">{{'showPreview'|translate}}</button>
    </div>

  </div>
</div>




<ng-template #validCircle><span class="circle-valid">
  <mat-icon>done</mat-icon>
                  </span>
</ng-template>
<ng-template #errorIcon><span class="invalid-selected">
  <img alt="warning" src="assets/svg-icons/warning_amber.svg"> </span>
</ng-template>
<ng-template #emptyCircle><span class="circle">
                  </span></ng-template>

<ng-template #spinnerCircle><span class="spinner-container">
  <mat-spinner diameter="18"></mat-spinner>
</span></ng-template>

<ng-template #selectedCircle><span class="circle selected-circle">
                  </span></ng-template>

<app-lob-modal [(showLobModal)]="showLobModal"></app-lob-modal>


